module.exports = __webpack_public_path__ + "static/media/Calc.4ce662a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/subject_icons/Calc.svg
// module id = 882
// module chunks = 21